import * as Yup from 'yup';

export const cpfValidation = async (cpf: string) => {
  const schema = Yup.string().test('validateCPF', 'CPF inválido', (value) => {
    let Soma;
    let Resto;
    Soma = 0;
    const strCPF = value.replace(/[^\d]+/g, '');

    if (strCPF.length > 11) return false;
    if (strCPF == '00000000000') return false;

    for (let i = 1; i <= 9; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  });

  await schema.validate(cpf, {
    abortEarly: false,
  });
};

export const cpfMask = (value: string): string => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const cleanCpf = (value: string): string => {
  return value.replace(/[^\d]+/g, '');
};

export const checkCpf = (value: string): any => {
  const isCpfTest = cleanCpf(value);
  if (isCpfTest.replace(/[^\d]+/g, '').length === 11 && !Number.isNaN(Number(isCpfTest))) {
    return { userFormatted: cpfMask(value), hasCpf: true };
  }
  return { userFormatted: value, hasCpf: false };
};
